import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Components
// import HelpText from '../../../components/HelpText'

// Actions
import { getForsiData } from '../../../../actions/orders'

// Utils
import { translation } from '../../../../utils/helpers'

// Components
import Text from '../../../elements/text'
import Button from '../../../elements/button'
// import LabelWrapper from '../../../elements/labelWrapper'
import Divider from '../../../elements/divider'

class Forsi extends Component {
  constructor (props) {
    super(props)

    this.state = {
      ForsiID: '',
      forsiIsLoading: false
    }

    this.renderButtonText = this.renderButtonText.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onButtonClick = this.onButtonClick.bind(this)
  }

  renderButtonText (text) {
    if (this.state.forsiIsLoading) {
      return (
        <span className='animated-background'>
          <i className='fa fa-spinner fa-spin fa-x fa-fw' style={{ lineHeight: '13px' }} />
        </span>
      )
    }
    return translation(text)
  }

  onInputChange (e) {
    this.setState({
      ForsiID: e.target.value
    })
  }

  onButtonClick (e) {
    if (typeof e.key === 'undefined' || e.key === 'Enter') {
      e.preventDefault()
      if (this.state.ForsiID === '') {
        window.toastr.error(translation('13428'), translation('216'))
        return false
      }
      this.state.ForsiID = this.state.ForsiID.replace(' ', '')
      this.setState({
        ...this.state,
        forsiIsLoading: true
      })
      this.props.getForsiData(this.state.ForsiID).then((res) => {
        this.setState({
          ...this.state,
          forsiIsLoading: false
        })
        if (res.data.AddedOrderId !== 0) {
          this.props.redirectToOrder(res.data.AddedOrderId)
        } else {
          if (res.data.Error !== undefined && res.data.Error !== null) {
            let errorString = translation(res.data.Error.DictionaryKey)
            if (errorString.indexOf('[orderstep]') !== -1) {
              errorString = errorString.replace('[orderstep]', res.data.Error.Parameters[0])
            }
            if (errorString.indexOf('[chainName]') !== -1) {
              errorString = errorString.replace('[chainName]', res.data.Error.Parameters[0])
            }
            window.toastr.error(errorString, translation('216'))
          } else {
            window.toastr.error(translation('960'), translation('216'))
          }
        }
      }, () => {
        window.toastr.error(translation('960'), translation('216'))
        this.setState({
          ...this.state,
          forsiIsLoading: false
        })
      })
    }
  }

  render () {
    let helpText = '1933' // FORSI
    if (this.props.auth.permissions.ChainAssessmentSystem === 2) helpText = '18041' // DBS

    return (
      <form autoComplete='off'>
        <Text
          labelText={translation('13427')}
          helpText={translation(helpText)}
          name='ForsiID'
          value={this.state.ForsiID}
          onChange={this.onInputChange}
          // autoComplete='off'
          onKeyPress={this.onButtonClick} />
        <Button
          labelText={this.renderButtonText('2038')}
          onClick={this.onButtonClick}
          style='link'
        />
        <Divider />
      </form>
    )
  }
}

Forsi.propTypes = {
  getForsiData: PropTypes.func.isRequired,
  redirectToOrder: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getForsiData
})(Forsi)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/Forsi/index.js